import React from "react";

function Timeline() {
    return (
      <div style={styles.container}>
        <h1 style={styles.heading}>Our Firsts as a Couple 💖</h1>

        {/* Timeline Container */}
        <div style={styles.timelineContainer}>
          {/* Milestone 1 */}
          <div style={styles.milestone}>
            <img
              src="photo1.jpeg" // Replace with your photo file name
              alt="Valentine's Day"
              style={styles.image}
            />
            <div style={styles.text}>
              <h3 style={styles.milestoneTitle}>Valentine's Day</h3>
              <p><strong>Date:</strong> 2/24/2024</p>
              <p><strong>Location:</strong> 21 Oceanfront</p>
              <p><strong>Memory:</strong> Finally got to take you out and convince you that Valentine's Day isn't tooooo bad ;)</p>
            </div>
          </div>

          {/* Milestone 2 */}
          <div style={styles.milestone}>
            <img
              src="photo2.jpeg" // Replace with your photo file name
              alt="Disney Trip"
              style={styles.image}
            />
            <div style={styles.text}>
              <h3 style={styles.milestoneTitle}>Disney Trip</h3>
              <p><strong>Date:</strong> 01/15/2024</p>
              <p><strong>Location:</strong> Disneyland!</p>
              <p><strong>Memory:</strong> Started our Car's Land tradition 💖</p>
            </div>
          </div>

          {/* Milestone 3 */}
          <div style={styles.milestone}>
            <img
              src="photo3.jpeg" // Replace with your photo file name
              alt="School Show"
              style={styles.image}
            />
            <div style={styles.text}>
              <h3 style={styles.milestoneTitle}>School Show</h3>
              <p><strong>Date:</strong> 02/29/2024</p>
              <p><strong>Location:</strong> Performing Arts Center</p>
              <p><strong>Memory:</strong> Your favorite red shirt</p>
            </div>
          </div>

          {/* Add more milestones as needed */}
          <div style={styles.milestone}>
            <img
              src="photo4.jpeg" // Replace with your photo file name
              alt="Official"
              style={styles.image}
            />
            <div style={styles.text}>
              <h3 style={styles.milestoneTitle}>Made you my girlfriend 💖</h3>
              <p><strong>Date:</strong> 03/24/2024</p>
              <p><strong>Location:</strong> CVS Parking Lot</p>
              <p><strong>Memory:</strong> Pulled a baddieeeee</p>
            </div>
          </div>
          <div style={styles.milestone}>
            <img
              src="photo5.jpeg" // Replace with your photo file name
              alt="Pantages Show"
              style={styles.image}
            />
            <div style={styles.text}>
              <h3 style={styles.milestoneTitle}>Pantages Show</h3>
              <p><strong>Date:</strong> 05/11/2024</p>
              <p><strong>Location:</strong> Pantages</p>
              <p><strong>Memory:</strong> First of many!!</p>
            </div>
          </div>
          <div style={styles.milestone}>
            <img
              src="photo6.jpeg" // Replace with your photo file name
              alt="Concert"
              style={styles.image}
            />
            <div style={styles.text}>
              <h3 style={styles.milestoneTitle}>Concert</h3>
              <p><strong>Date:</strong> 05/29/2024</p>
              <p><strong>Location:</strong> The Regent Theater</p>
              <p><strong>Memory:</strong> The Scarlet Opera!</p>
            </div>
          </div>
          <div style={styles.milestone}>
            <img
              src="photo7.jpeg" // Replace with your photo file name
              alt="Spag Fac"
              style={styles.image}
            />
            <div style={styles.text}>
              <h3 style={styles.milestoneTitle}>Spag Fac</h3>
              <p><strong>Date:</strong> 06/28/2024</p>
              <p><strong>Location:</strong> Spaghetti Factory</p>
              <p><strong>Memory:</strong> The start of our favorite place to eat 💖</p>
            </div>
          </div>
          <div style={styles.milestone}>
            <img
              src="photo8.jpeg" // Replace with your photo file name
              alt="Canter's"
              style={styles.image}
            />
            <div style={styles.text}>
              <h3 style={styles.milestoneTitle}>Canter's!</h3>
              <p><strong>Date:</strong> 07/20/2024</p>
              <p><strong>Location:</strong> Canter's Deli</p>
              <p><strong>Memory:</strong> Jewish food!!</p>
            </div>
          </div>
          <div style={styles.milestone}>
            <img
              src="photo9.jpeg" // Replace with your photo file name
              alt="RTF"
              style={styles.image}
            />
            <div style={styles.text}>
              <h3 style={styles.milestoneTitle}>RTF</h3>
              <p><strong>Date:</strong> Summer 2024</p>
              <p><strong>Location:</strong> Redland's Theatre Festival</p>
              <p><strong>Memory:</strong> RIP</p>
            </div>
          </div>
          <div style={styles.milestone}>
            <img
              src="photo10.jpeg" // Replace with your photo file name
              alt="My Birthday"
              style={styles.image}
            />
            <div style={styles.text}>
              <h3 style={styles.milestoneTitle}>My Birthday</h3>
              <p><strong>Date:</strong> 08/11/2024</p>
              <p><strong>Location:</strong> Your house</p>
              <p><strong>Memory:</strong> Best birthday party ever 💖</p>
            </div>
          </div>
          <div style={styles.milestone}>
            <img
              src="photo11.jpeg" // Replace with your photo file name
              alt="OC Fair"
              style={styles.image}
            />
            <div style={styles.text}>
              <h3 style={styles.milestoneTitle}>OC Fair</h3>
              <p><strong>Date:</strong> 08/11/2024</p>
              <p><strong>Location:</strong> OC Fair</p>
              <p><strong>Memory:</strong> Don't worry, you don't get wet on the log ride</p>
            </div>
          </div>
          <div style={styles.milestone}>
            <img
              src="photo12.jpeg" // Replace with your photo file name
              alt="Costco Trip"
              style={styles.image}
            />
            <div style={styles.text}>
              <h3 style={styles.milestoneTitle}>Costco Trip</h3>
              <p><strong>Date:</strong> 09/15/2024</p>
              <p><strong>Location:</strong> Costco</p>
              <p><strong>Memory:</strong> $1.50 Hot Dogsssss</p>
            </div>
          </div>
          <div style={styles.milestone}>
            <img
              src="photo13.jpeg" // Replace with your photo file name
              alt="Arcade"
              style={styles.image}
            />
            <div style={styles.text}>
              <h3 style={styles.milestoneTitle}>Arcade Photoshoot</h3>
              <p><strong>Date:</strong> 10/11/2024</p>
              <p><strong>Location:</strong> Arcade</p>
              <p><strong>Memory:</strong> Best prize was you 💖</p>
            </div>
          </div>
          <div style={styles.milestone}>
            <img
              src="photo14.jpeg" // Replace with your photo file name
              alt="Yom Kippur"
              style={styles.image}
            />
            <div style={styles.text}>
              <h3 style={styles.milestoneTitle}>Yom Kippur!</h3>
              <p><strong>Date:</strong> 10/12/2024</p>
              <p><strong>Location:</strong> Uncle Brad's House</p>
              <p><strong>Memory:</strong> Meeting your extended family!</p>
            </div>
          </div>
          <div style={styles.milestone}>
            <img
              src="photo15.jpeg" // Replace with your photo file name
              alt="Pumpkin Patch"
              style={styles.image}
            />
            <div style={styles.text}>
              <h3 style={styles.milestoneTitle}>Pumpkin Patch</h3>
              <p><strong>Date:</strong> 10/14/2024</p>
              <p><strong>Location:</strong> Oak Glen Pumpkin Patch</p>
              <p><strong>Memory:</strong> Had to carve those moldy pumpkins</p>
            </div>
          </div>
          <div style={styles.milestone}>
            <img
              src="photo16.jpeg" // Replace with your photo file name
              alt="Scary Farm"
              style={styles.image}
            />
            <div style={styles.text}>
              <h3 style={styles.milestoneTitle}>Scary Farm!</h3>
              <p><strong>Date:</strong> 10/17/2024</p>
              <p><strong>Location:</strong> Knott's Scary Farm</p>
              <p><strong>Memory:</strong> Can't be scared when I've got the hottest girl alive next to me</p>
            </div>
          </div>
          <div style={styles.milestone}>
            <img
              src="photo17.jpeg" // Replace with your photo file name
              alt="Your Birthday"
              style={styles.image}
            />
            <div style={styles.text}>
              <h3 style={styles.milestoneTitle}>💖 Your Birthday! 💖</h3>
              <p><strong>Date:</strong> 10/25/2024</p>
              <p><strong>Location:</strong> Disneyland</p>
              <p><strong>Memory:</strong> Celebrating my love 💖</p>
            </div>
          </div>
          <div style={styles.milestone}>
            <img
              src="photo18.jpeg" // Replace with your photo file name
              alt="Halloween"
              style={styles.image}
            />
            <div style={styles.text}>
              <h3 style={styles.milestoneTitle}>Halloween</h3>
              <p><strong>Date:</strong> 10/31/2024</p>
              <p><strong>Location:</strong> Your Bed</p>
              <p><strong>Memory:</strong> The perfect night in with my girl 💖</p>
            </div>
          </div>
          <div style={styles.milestone}>
            <img
              src="photo19.jpeg" // Replace with your photo file name
              alt="Home Depot"
              style={styles.image}
            />
            <div style={styles.text}>
              <h3 style={styles.milestoneTitle}>Home Depot Trip</h3>
              <p><strong>Date:</strong> 11/23/2024</p>
              <p><strong>Location:</strong> Home Depot</p>
              <p><strong>Memory:</strong> The land of our people</p>
            </div>
          </div>
          <div style={styles.milestone}>
            <img
              src="photo20.jpeg" // Replace with your photo file name
              alt="Todd's Company Party"
              style={styles.image}
            />
            <div style={styles.text}>
              <h3 style={styles.milestoneTitle}>Todd's Company Christmas Party</h3>
              <p><strong>Date:</strong> 12/22/2024</p>
              <p><strong>Location:</strong> Dapper's</p>
              <p><strong>Memory:</strong> Honored to be the date of company royalty</p>
            </div>
          </div>
          <div style={styles.milestone}>
            <img
              src="photo21.jpeg" // Replace with your photo file name
              alt="Gingerbread Houses"
              style={styles.image}
            />
            <div style={styles.text}>
              <h3 style={styles.milestoneTitle}>Gingerbread Houses!</h3>
              <p><strong>Date:</strong> 10/23/2024</p>
              <p><strong>Location:</strong> Your House</p>
              <p><strong>Memory:</strong> New Christmas tradition! Maybe..</p>
            </div>
          </div>
          <div style={styles.milestone}>
            <img
              src="photo22.jpeg" // Replace with your photo file name
              alt="Christmas/Hanukkah"
              style={styles.image}
            />
            <div style={styles.text}>
              <h3 style={styles.milestoneTitle}>Christmas/Hanukkah</h3>
              <p><strong>Date:</strong> 12/25/2024 & 01/04/2025</p>
              <p><strong>Location:</strong> Your house and Uncle Brad's</p>
              <p><strong>Memory:</strong> We don't have pictures for either of these.. so here's our Christmas Card</p>
            </div>
          </div>
          <div style={styles.milestone}>
            <img
              src="photo23.jpeg" // Replace with your photo file name
              alt="Ice Skating"
              style={styles.image}
            />
            <div style={styles.text}>
              <h3 style={styles.milestoneTitle}>Ice Skating!</h3>
              <p><strong>Date:</strong> 12/26/2024</p>
              <p><strong>Location:</strong> Ice Town</p>
              <p><strong>Memory:</strong> Humbled very quickly.. loved the view of you skating ahead of me though ;)</p>
            </div>
          </div>
          <div style={styles.milestone}>
            <img
              src="photo24.jpeg" // Replace with your photo file name
              alt="New Year's Eve"
              style={styles.image}
            />
            <div style={styles.text}>
              <h3 style={styles.milestoneTitle}>New Year's Eve</h3>
              <p><strong>Date:</strong> 12/31/2024</p>
              <p><strong>Location:</strong> Your House</p>
              <p><strong>Memory:</strong> My forever NYE'S kiss 💖</p>
            </div>
          </div>
          <div style={styles.milestone}>
            <img
              src="photo25.jpeg" // Replace with your photo file name
              alt="Road Trip"
              style={styles.image}
            />
            <div style={styles.text}>
              <h3 style={styles.milestoneTitle}>Road Trip</h3>
              <p><strong>Date:</strong> 01/07/2025</p>
              <p><strong>Location:</strong> Utah</p>
              <p><strong>Memory:</strong> We 💖 Beaver!</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  export default Timeline;


// Styles
const styles = {
    container: {
      textAlign: 'center',
      padding: '40px 20px',
      background: 'linear-gradient(135deg, #ff9a9e 0%, #fad0c4 100%)',
      minHeight: '100vh',
      fontFamily: "'Dancing Script', cursive, sans-serif",
      color: '#333',
    },
    heading: {
      fontSize: '48px',
      marginBottom: '40px',
      color: '#fff',
      textShadow: '2px 2px 4px rgba(0, 0, 0, 0.3)',
    },
    timelineContainer: {
      maxWidth: '800px',
      margin: '0 auto',
      textAlign: 'left',
    },
    milestone: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '30px',
      padding: '20px',
      background: 'rgba(255, 255, 255, 0.8)',
      borderRadius: '15px',
      boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
      transition: 'transform 0.3s ease, box-shadow 0.3s ease',
    },
    milestoneHover: {
      transform: 'scale(1.02)',
      boxShadow: '0 6px 15px rgba(0, 0, 0, 0.2)',
    },
    image: {
      width: '120px',
      height: '120px',
      borderRadius: '15px',
      marginRight: '20px',
      objectFit: 'cover',
      border: '3px solid #fff',
      boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
    },
    text: {
      flex: 1,
    },
    milestoneTitle: {
      fontSize: '28px',
      marginBottom: '10px',
      color: '#ff6f61',
      textShadow: '1px 1px 2px rgba(0, 0, 0, 0.1)',
    },
  };
